// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"72e43ce2","435":"adb2b5f1","442":"d482cc09","453":"d48df938","574":"8b0f88d8","642":"e98a4b17","703":"a420acee","728":"ff5aaa71","872":"0f2ab719","994":"28a8e54e"}[chunkId] + ".chunk.js";
};